import { useState } from 'react';

export function useActiveQuestion<T>(connectedQuestions: Array<T>) {
  const [activeQuestionIdx, setActiveQuestionIdx] = useState<number>(0);
  const activeQuestion = connectedQuestions[activeQuestionIdx];
  const questionsCount = connectedQuestions.length;

  const markNextQuestionAsActive = () => {
    const isLastQuestion = activeQuestionIdx + 1 === connectedQuestions.length;
    if (isLastQuestion) {
      return;
    }
    setActiveQuestionIdx(activeQuestionIdx + 1);
  };

  const markLastQuestionAsActive = () => {
    setActiveQuestionIdx(connectedQuestions.length - 1);
  };

  const markQuestionAsActiveByIdx = (idx: number) => {
    if (idx >= connectedQuestions.length) {
      markLastQuestionAsActive();
    } else {
      setActiveQuestionIdx(idx);
    }
  };

  return {
    activeQuestion,
    activeQuestionIdx,
    markNextQuestionAsActive,
    markQuestionAsActiveByIdx,
    questionsCount,
  };
}
